import React, { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import Vector from "../../Assets/Images/Auth.svg";
import Logo from "../../Assets/Images/Logo-xsmall.svg";
import UserActive from "../../Assets/Images/user-active.svg";
import User from "../../Assets/Images/User.svg";
import axios from "axios";
import { Config } from "../../Config";
import AuthTextInput from "../Dashboard/Components/ShareElements/TextInput/AuthTextInput";
import LoadingIcon from "../../Assets/Images/ButtonLoadingIcon.svg";
import Alert from "../../Assets/Images/alert-triangle.svg";
import Disabled from "../../Assets/Images/DisabledAccount.svg";

const ResetPassword = () => {
  const [IsLoading, setIsLoading] = useState(false);
  const [AccountIsDisabled, setIsDisabled] = useState(false);

  // e stands for event initiated by the user and passed to the function where it is called
  const goBack = (e) => {
    e.preventDefault();
    window.location.assign("../");
  };
  const requestPasswordReset = (e) => {
    let RegEx = /\S+@\S+\.\S+/;
    e.preventDefault();
    const Username = document.getElementById("username").value;
    if (Username.length === 0) {
      showUsernameError();
      setTimeout(() => {
        hideUsernameError();
      }, 3000);
    } else if (!Username.match(RegEx)) {
      showWrongFormatError();
    } else {
      sendResetRequest();
      setTimeout(() => {
        hideToast();
      }, 4000);
    }
  };
  const showWrongFormatError = () => {
    document.getElementById("username-input").classList.add("wrong-input");
    document
      .getElementById("wrong-format")
      .classList.add("wrong-cridentials-message-is-shown");
  };
  const hideWrongFormatError = () => {
    document.getElementById("username-input").classList.remove("wrong-input");
    document
      .getElementById("wrong-format")
      .classList.remove("wrong-cridentials-message-is-shown");
  };
  const showUsernameError = () => {
    document.getElementById("username-input").classList.add("wrong-input");
    document
      .getElementById("empty-username")
      .classList.add("wrong-cridentials-message-is-shown");
  };
  const hideUsernameError = () => {
    document.getElementById("username-input").classList.remove("wrong-input");
    document
      .getElementById("empty-username")
      .classList.remove("wrong-cridentials-message-is-shown");
  };
  const showWrongUsernameError = () => {
    document.getElementById("username-input").classList.add("wrong-input");
    document
      .getElementById("wrong-username")
      .classList.add("wrong-cridentials-message-is-shown");
  };
  const hideWrongUsernameError = () => {
    document.getElementById("username-input").classList.remove("wrong-input");
    document
      .getElementById("wrong-username")
      .classList.remove("wrong-cridentials-message-is-shown");
  };
  const hideToast = () => {
    document.getElementById("toast").classList.remove("toast-is-shown");
  };

  const sendResetRequest = () => {
    setIsLoading(true);
    let Data = {
      email: document.getElementById("username").value,
    };
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/forget-password",
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setIsLoading(false);
        document.getElementById("toast").classList.add("toast-is-shown");
      })
      .catch((Err) => {
        console.log(Err.response);
        setIsLoading(false);
        if (Err.response.status === 404) {
          showWrongUsernameError();
        }
        if (Err.response.data.messages[0] === "User account is locked") {
          setIsDisabled(true);
          document.getElementById("vector").src = Disabled;
        }
      });
  };
  const removeErrors = () => {
    hideUsernameError();
    hideWrongFormatError();
    hideWrongUsernameError();
  };
  return (
    <BrowserRouter>
      <div className="auth">
        <div className="column banner-area is-two-fifths">
          <img
            alt="Login to connexing"
            className="login-vector"
            id="vector"
            src={Vector}
          />
        </div>
        <div className="column auth-form-area is-two-thirds">
          <div className="auth-form">
            {AccountIsDisabled ? (
              <section className="locked-state">
                <img className="logo" alt="login" src={Logo} />
                <img src={Alert} alt="!" className="alert-image" />
                <h3>Your Account is Locked.</h3>
                <p>
                  You’ve entered too many wrong passwords. Please contact the
                  Admin.
                </p>
              </section>
            ) : (
              <form className="column">
                <img className="logo" alt="login" src={Logo} />
                <p className="form-title">Forgot Password</p>
                <p className="info">Reset your account password.</p>
                <AuthTextInput
                  Icon={User}
                  ActiveIcon={UserActive}
                  BlurAction={() => removeErrors()}
                  PlaceHolder="Username/Email"
                  Id="username"
                  type="text"
                />
                <p className="wrong-cridentials-message" id="empty-username">
                  Enter your username.
                </p>
                <p className="wrong-cridentials-message" id="wrong-format">
                  Please enter a valid Email address.
                </p>
                <p className="wrong-cridentials-message" id="wrong-username">
                  The email that you've entered does not exist.
                </p>
                <section className="reset-options">
                  <button onClick={(e) => goBack(e)} className="cancel">
                    Cancel
                  </button>
                  {IsLoading ? (
                    <button className="login-btn reset-btn disabled-btn">
                      <img className="rotator" src={LoadingIcon} alt="" />
                    </button>
                  ) : (
                    <button
                      onClick={(e) => requestPasswordReset(e)}
                      className="send-email-btn"
                    >
                      Reset Password
                    </button>
                  )}
                </section>
              </form>
            )}
            <div className="toast" id="toast">
              <p>Reset password link has been sent to your email.</p>
              <button onClick={() => hideToast()}>DISMISS</button>
            </div>
          </div>
        </div>
      </div>
    </BrowserRouter>
  );
};
export default ResetPassword;
